"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateProductSalableForm = CreateProductSalableForm;
exports.setInitialImagesOfProductValues = exports.setImagesValuesToFormData = exports.getFormInitialValuesKeys = exports.INDEX_POWER = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _lodash = _interopRequireDefault(require("lodash"));
var _ProductCreationRender = _interopRequireDefault(require("./components/ProductCreationRender"));
var _index = require("../../config/index");
var _formik = require("formik");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _index2 = require("react-platform-components/dist/helpers/index");
var _InformationStep = require("./steps/InformationStep");
var _ShippingStep = require("./steps/ShippingStep");
var _AddressOfProductStep = require("./steps/AddressOfProductStep");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SpecificitiesOfProductFields = null;
var setSpecificitiesValuesToFormData = null;
var setInitialSpecificitiesOfProductValues = null;
try {
  SpecificitiesOfProductFields = require("react-platform-specificity-of-product/dist/SpecificityOfProductWithSections/SpecificitiesOfProductFields").SpecificitiesOfProductFields;
  setSpecificitiesValuesToFormData = require("react-platform-specificity-of-product/dist/SpecificityOfProductWithSections/SpecificitiesOfProductFields").setSpecificitiesValuesToFormData;
  setInitialSpecificitiesOfProductValues = require("react-platform-specificity-of-product/dist/SpecificityOfProductWithSections/SpecificitiesOfProductFields").setInitialSpecificitiesOfProductValues;
} catch (error) {}
var CategoryOfProductNotFinal = null;
try {
  if (_index.USE_NEW_DESIGN_OF_CATEGORIES_OF_PRODUCT_FIELD) {
    CategoryOfProductNotFinal = require("react-platform-category-of-product/dist/CategoryOfProduct/CategoryOfProductField/CategoryOfProductField").CategoryOfProductField;
  } else {
    CategoryOfProductNotFinal = require("react-platform-category-of-product/dist/CategoryOfProduct/CategoryOfProductField").default;
  }
} catch (e) {}
var CautionField = null;
var setCautionValuesToFormData = null;
var setInitialCautionOfProductValues = null;
try {
  CautionField = require('react-platform-caution/dist/CautionField/CautionField').CautionField;
  setCautionValuesToFormData = require('react-platform-caution/dist/CautionField/CautionField').setCautionValuesToFormData;
  setInitialCautionOfProductValues = require('react-platform-caution/dist/CautionField/CautionField').setInitialCautionOfProductValues;
} catch (error) {
  console.log('module caution not exist');
}
var getFormInitialValuesKeys = function getFormInitialValuesKeys() {
  var initialValuesKeys = ["name", "description", "price", "images"];
  CategoryOfProductNotFinal && initialValuesKeys.push("category");
  if (_index.SHOW_QUANTITY_FIELD_IN_PRODUCT_CREATION) {
    initialValuesKeys.push("quantity");
  }
  _ShippingStep.ShippingStepFields && initialValuesKeys.push("shipping");
  SpecificitiesOfProductFields && initialValuesKeys.push("specificities");
  _AddressOfProductStep.AddressOfProductFields && initialValuesKeys.push("address");
  CautionField && initialValuesKeys.push("product_caution");
  return initialValuesKeys;
};
exports.getFormInitialValuesKeys = getFormInitialValuesKeys;
var setShippingValuesToFormData = null;
var setInitialShippingValues;
try {
  setShippingValuesToFormData = require("react-platform-shipping/dist/form-fields/ShippingField/ShippingField").setShippingValuesToFormData;
  setInitialShippingValues = require("react-platform-shipping/dist/form-fields/ShippingField/ShippingField").setInitialShippingValues;
} catch (error) {}
var setInitialAddressOfProductValues = null;
try {
  setInitialAddressOfProductValues = require("react-platform-address-of-product/dist/AddressOfProduct/AddressOfProductFields").setInitialAddressOfProductValues;
} catch (error) {}
var hasReservationOption = false;
try {
  hasReservationOption = Boolean(require('react-platform-reservation/dist/Reservation/index').default);
} catch (error) {}
var setInitialImagesOfProductValues = function setInitialImagesOfProductValues(product) {
  var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'images';
  if (!product) return {};
  return _defineProperty({}, fieldName, product[fieldName] ? product[fieldName] : []);
};
exports.setInitialImagesOfProductValues = setInitialImagesOfProductValues;
var setImagesValuesToFormData = function setImagesValuesToFormData(formData, key, data) {
  var deletionKey = "".concat(key, "ToDelete");
  // data[deletionKey] contain the ids of images will want to delete
  _lodash.default.forEach(data[deletionKey], function (imageId, index) {
    formData.append("".concat(key, "-").concat(index, "-id"), imageId);
    formData.append("".concat(key, "-").concat(index, "-inline_delete"), "true");
  });
  var indexPower = 10000;
  var deleteItemsLength = (data[deletionKey] || []).length;
  _lodash.default.forEach(data[key], function (image, index) {
    if (image.file) {
      formData.append("".concat(key, "-").concat(index + indexPower, "-name"), image.file);
      formData.append("".concat(key, "-").concat(index + indexPower, "-type"), image.type);
    } else {
      // update case, we save the same old image data
      formData.append("".concat(key, "-").concat(index + deleteItemsLength, "-id"), image.id);
      formData.append("".concat(key, "-").concat(index + deleteItemsLength, "-type"), image.type);
    }
  });
  formData.delete(key);
  formData.delete(deletionKey);
};
exports.setImagesValuesToFormData = setImagesValuesToFormData;
var INDEX_POWER = 100;
exports.INDEX_POWER = INDEX_POWER;
function CreateProductSalableForm(props) {
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    drawerWidth = _useState2[0],
    setDrawerWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    activeStep = _useState4[0],
    setActiveStep = _useState4[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  var location = (0, _reactRouterDom.useLocation)();
  var initialValues = (0, _react.useRef)({});
  var stepsContent = [{
    label: "Informations step",
    component: _InformationStep.InformationsStepFields
  }];
  if (_ShippingStep.ShippingStepFields) {
    stepsContent.push({
      label: "Shipping step",
      component: _ShippingStep.ShippingStepFields
    });
  }
  if (_AddressOfProductStep.AddressOfProductFields) {
    stepsContent.push({
      label: "Address step",
      component: _AddressOfProductStep.AddressOfProductFields
    });
  }
  stepsContent = props.getStepsContent ? props.getStepsContent(stepsContent) : stepsContent;
  var renderSteps = function renderSteps() {
    var Step = stepsContent[activeStep].component;
    return /*#__PURE__*/_react.default.createElement(Step, null);
  };
  var renderStepsLabel = (0, _react.useCallback)(function () {
    return stepsContent.map(function (item) {
      return item.label;
    });
  }, []);
  var params = (0, _reactRouterDom.useParams)();
  var history = (0, _reactRouterDom.useHistory)();
  var steps = renderStepsLabel();
  var isUpdating = Boolean(params.id);
  (0, _react.useEffect)(function () {
    var time = setTimeout(function () {
      var _document$querySelect;
      var width = (_document$querySelect = document.querySelector(".MuiDrawer-root.MuiDrawer-docked")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.clientWidth;
      if (width !== drawerWidth) {
        setDrawerWidth(width);
      }
    }, 100);
    return function () {
      return clearTimeout(time);
    };
  });
  var state = (0, _reactRedux.useSelector)(function (state) {
    var _state$categoryOfProd, _state$specificityOfP, _state$shippingReduce, _state$shippingReduce2, _state$storeReducer, _state$storeReducer$s, _state$ProductReducer, _state$productSalable, _state$CautionReducer;
    return _objectSpread(_objectSpread({
      categories: (_state$categoryOfProd = state.categoryOfProductReducer) === null || _state$categoryOfProd === void 0 ? void 0 : _state$categoryOfProd.categories,
      product: state.ProductReducer.product,
      inProgress: state.ProductReducer.inProgress,
      specificities: (_state$specificityOfP = state.specificityOfProductReducer) === null || _state$specificityOfP === void 0 ? void 0 : _state$specificityOfP.specificities
    }, (_state$shippingReduce = state.shippingReducer) !== null && _state$shippingReduce !== void 0 && _state$shippingReduce.shippingOption ? {
      shippingOption: (_state$shippingReduce2 = state.shippingReducer) === null || _state$shippingReduce2 === void 0 ? void 0 : _state$shippingReduce2.shippingOption
    } : null), {}, {
      user: state.auth.user,
      addressOfStore: state === null || state === void 0 ? void 0 : (_state$storeReducer = state.storeReducer) === null || _state$storeReducer === void 0 ? void 0 : (_state$storeReducer$s = _state$storeReducer.store) === null || _state$storeReducer$s === void 0 ? void 0 : _state$storeReducer$s.address,
      productSavedAsDraft: (_state$ProductReducer = state.ProductReducer) === null || _state$ProductReducer === void 0 ? void 0 : _state$ProductReducer.productSavedAsDraft,
      productSalableCommission: state === null || state === void 0 ? void 0 : (_state$productSalable = state.productSalableReducer) === null || _state$productSalable === void 0 ? void 0 : _state$productSalable.commissions,
      caution: state === null || state === void 0 ? void 0 : (_state$CautionReducer = state.CautionReducer) === null || _state$CautionReducer === void 0 ? void 0 : _state$CautionReducer.cautionValues[0]
    }, hasReservationOption && {
      reservationOption: state.reservationReducer.reservation_option
    });
  });
  var product = params.id ? state.product : {};
  initialValues.current = _lodash.default.merge.apply(_lodash.default, [initialValues.current].concat(_toConsumableArray((props.getFormInitialValuesKeys || getFormInitialValuesKeys)().map(function (key) {
    if (key === "shipping" && !_lodash.default.isEmpty(product)) {
      return setInitialShippingValues(product, state.shippingOption.id, key);
    } else if (key === "category") {
      return _defineProperty({}, key, product && product[key] && product[key].id || "");
    } else if (key === "specificities") {
      if (!state.specificities) return {};
      return setInitialSpecificitiesOfProductValues(product, "specificities", {
        specificities: state.specificities,
        categories: state.categories
      });
    } else if (key === "price") {
      return _defineProperty({}, key, product && product[key] || "");
    } else if (key === "name") {
      return _defineProperty({}, key, product && product[key] || "");
    } else if (key === "description") {
      return _defineProperty({}, key, product && product[key] || "");
    } else if (key === "product-category") {
      return _defineProperty({}, key, product && product[key] || "");
    } else if (key === "images") {
      return setInitialImagesOfProductValues(product);
    } else if (key === "address") {
      return setInitialAddressOfProductValues(product, state === null || state === void 0 ? void 0 : state.addressOfStore);
    } else if (key === "product_caution") {
      return setInitialCautionOfProductValues(product, "product_caution", state.caution);
    } else {
      return _defineProperty({}, key, product && product[key] || "");
    }
  }))));
  if (props.getCustomInitialValues) {
    initialValues.current = props.getCustomInitialValues(initialValues.current, product);
  }
  var formik = (0, _formik.useFormik)({
    initialValues: initialValues.current,
    enableReinitialize: true,
    onSubmit: function onSubmit(values) {
      return handleSubmit(values);
    }
  });
  var handleNext = function handleNext() {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
    (0, _index2.scrollToTop)();
  };
  var handleBack = function handleBack() {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep - 1;
    });
    (0, _index2.scrollToTop)();
  };
  var handleSubmit = function handleSubmit(values) {
    if (activeStep < steps.length - 1) {
      handleNext();
      return;
    }
    handleSave(values);
  };
  var handleSave = props.handleSave ? props.handleSave : function (values) {
    var _state$user, _state$user2, _props$onSave, _props$onSave$hasRese, _props$onSave2, _props$onSave3, _props$onSave4, _state$productSavedAs;
    // Check if we are on updating for creating a product case
    var isUpdating = Boolean(params.id);
    // if the status draf or refused must be changed to waiting
    var data = !_lodash.default.includes(["refused", "draft"], values.status) && (product === null || product === void 0 ? void 0 : product.status) !== "published" ? _objectSpread(_objectSpread({}, values), {}, {
      user: state === null || state === void 0 ? void 0 : (_state$user = state.user) === null || _state$user === void 0 ? void 0 : _state$user.id,
      status: "waiting"
    }) : _objectSpread(_objectSpread({}, values), {}, {
      user: state === null || state === void 0 ? void 0 : (_state$user2 = state.user) === null || _state$user2 === void 0 ? void 0 : _state$user2.id
    });
    var formData = new FormData();
    var excludedFields = ["images", "specificities", "principal", "images-to-delete"];
    if (!_index.PRODUCT_SHOULD_HAVE_PRICE) {
      excludedFields.push("price");
    }
    if ((_props$onSave = props.onSave) !== null && _props$onSave !== void 0 && _props$onSave.excludedFields) excludedFields = props.onSave.excludedFields(excludedFields);

    // This endpoint is used in the action (edit/create)
    var endpoint = props.endpoint || "salable-products";
    if (_index.SHOW_QUANTITY_FIELD_IN_PRODUCT_CREATION) {
      formData.append("quantity", data.quantity);
    } else {
      formData.append("quantity", 1);
    }
    if (props.excludedFields) {
      props.excludedFields.forEach(function (key) {
        return excludedFields.push(key);
      });
    }
    _lodash.default.forOwn(data, function (value, key) {
      if (excludedFields.indexOf(key) !== -1) {
        return;
      } else if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    setShippingValuesToFormData && setShippingValuesToFormData(formData, "shipping", state.shippingOption.id, data, state.product);
    setSpecificitiesValuesToFormData && setSpecificitiesValuesToFormData(formData, "product_specificities", data, state.product);
    setCautionValuesToFormData && setCautionValuesToFormData(formData, 'product_caution', data);
    setImagesValuesToFormData(formData, 'images', data);
    if ((_props$onSave$hasRese = (_props$onSave2 = props.onSave) === null || _props$onSave2 === void 0 ? void 0 : _props$onSave2.hasReservationOption) !== null && _props$onSave$hasRese !== void 0 ? _props$onSave$hasRese : hasReservationOption) {
      // Create reaservation product and option
      formData.append("product_options-9999-option", state.reservationOption.id);
    }
    if ((_props$onSave3 = props.onSave) !== null && _props$onSave3 !== void 0 && _props$onSave3.setAdditionalValuesToFormData) props.onSave.setAdditionalValuesToFormData(formData, _objectSpread(_objectSpread({}, values), data), product, isUpdating);
    var redirectAfterActionTo = props !== null && props !== void 0 && (_props$onSave4 = props.onSave) !== null && _props$onSave4 !== void 0 && _props$onSave4.redirectAfterActionTo ? props.onSave.redirectAfterActionTo(values, isUpdating) : "/product-salable";
    var isSaveAsDraft = data.status === "draft";
    var onSuccess = function onSuccess(product) {
      if (isSaveAsDraft) {
        // if we use save as draft we always stay on the same page
        dispatch({
          type: 'REDIRECT',
          to: redirectAfterActionTo,
          history: history
        });
        dispatch({
          type: "HANDLE_SUCCESS_MESSAGE",
          message: /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
            id: "Votre annonce a bien \xE9t\xE9 sauvegard\xE9e en tant que brouillon",
            defaultMessage: "Votre annonce a bien \xE9t\xE9 sauvegard\xE9e en tant que brouillon"
          })
        });
      } else {
        dispatch({
          type: 'REDIRECT',
          to: redirectAfterActionTo,
          history: history
        });
        dispatch({
          type: "HANDLE_SUCCESS_MESSAGE",
          message: isUpdating ? /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
            id: "Votre annonce a bien \xE9t\xE9 modifi\xE9e"
          }) : /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
            id: "Votre annonce a bien \xE9t\xE9 enregistr\xE9e"
          })
        });
      }
    };

    //check what type of we are doing to dispatch the right action
    if (isUpdating || !_lodash.default.isEmpty(state === null || state === void 0 ? void 0 : (_state$productSavedAs = state.productSavedAsDraft) === null || _state$productSavedAs === void 0 ? void 0 : _state$productSavedAs.id)) {
      dispatch({
        type: "UPDATE_PRODUCT",
        endpoint: endpoint,
        model: formData,
        id: params.id || (state === null || state === void 0 ? void 0 : state.productSavedAsDraft.id),
        history: history,
        onSuccess: onSuccess
      });
    } else {
      dispatch({
        type: "ADD_PRODUCT",
        endpoint: endpoint,
        productSavedAsDraft: isSaveAsDraft,
        model: formData,
        page: 1,
        history: history,
        onSuccess: onSuccess
      });
    }
  };
  var handleSaveAsDraft = function handleSaveAsDraft() {
    setTimeout(function () {
      handleSave(_objectSpread(_objectSpread({}, formik.values), {}, {
        "status": "draft",
        name: formik.values.name === "" ? 'Annonce Draft' : formik.values.name
      }));
    }, 100);
  };
  return /*#__PURE__*/_react.default.createElement(_formik.FormikContext.Provider, {
    value: formik
  }, /*#__PURE__*/_react.default.createElement(_ProductCreationRender.default, {
    formik: formik,
    inProgress: state.inProgress,
    match: params.id,
    handleBack: handleBack,
    handleSaveAsDraft: handleSaveAsDraft,
    product: product,
    activeStep: activeStep,
    drawerWidth: drawerWidth,
    isUpdating: isUpdating,
    fields: renderSteps(),
    stepsLabels: renderStepsLabel(),
    numberOfSteps: stepsContent.length - 1
  }));
}